import axios from "axios";
import { firebaseFunctionsUrl } from "../Helpers/FirebaseEnvironments";

export const getEnrichedCVRdata = async (data: string) => {
  try {
    const response = await axios.post(firebaseFunctionsUrl('getEnrichedCVRdata'), { data });
    return response.data;
  } catch (error) {
    console.error("Error calling Firebase function:", error);
    throw new Error("Error fetching data from Firebase function.");
  }
};
